import _Cookies from "universal-cookie";

import {
    COOKIE_JWT, COOKIE_REMEMBER
} from "@helper/constant";
import axios from "axios";

const cookie = new _Cookies();

export const setCookie = (key, value, expires = 1) => {
    try {
        let minutes = 1440;
        let d = new Date();
        d.setTime(d.getTime() + (minutes * 60 * 1000));
        cookie.set(key, value, { path: "/", expires: d });
    } catch (error) {
        // console.log({ error })
    }
};

export const removeCookie = (key) => {
    cookie.remove(key, {
        expires: 1,
    });
};

export const getCookie = (key, req) => {
    return process.browser
        ? getCookieFromBrowser(key)
        : getCookieFromServer(key, req);
};

export const getCookieFromBrowser = (key) => {
    try {
        return cookie.get(key);
    } catch (error) {
        // console.log({ error })
    }
};

export const getCookieFromServer = (key, req) => {
    if (!req.headers.cookie) {
        return undefined;
    }
    const rawCookie = req.headers.cookie
        .split(";")
        .find((c) => c.trim().startsWith(`${key}=`));
    if (!rawCookie) {
        return undefined;
    }
    return rawCookie.split("=")[1];
};

export const getAcessToken = (_ctx = null) => {
    let _accessToken = null;
    if (_ctx) {
        let { req = null } = _ctx || {};
        if (!req) return null;
        let ___cookies = new _Cookies(_ctx.req.headers.cookie);

        const value = ___cookies.get(COOKIE_JWT);

        if (value) _accessToken = value["accessToken"] || null;
    } else {
        let _cookieToken = cookie.get(COOKIE_JWT);
        if (_cookieToken != null && _cookieToken != undefined) {
            let { accessToken = '' } = _cookieToken || {};
            _accessToken = accessToken;
        }
    }
    return _accessToken;
};

export const getRefreshToken = (_ctx = null) => {
    let tokenObj = null;
    if (_ctx) {
        let ___cookies = new _Cookies(_ctx.req.headers.cookie);
        const value = ___cookies.get(COOKIE_JWT);
        let remember = ___cookies.get(COOKIE_REMEMBER) || false;
        if (value) {
            let refresh_data = Object.assign(value, { remember })
            tokenObj = refresh_data;
        }
    } else {
        let _cookieToken = cookie.get(COOKIE_JWT);
        let remember = cookie.get(COOKIE_REMEMBER) || false;
        if (_cookieToken != null && _cookieToken != undefined) {
            let resfresh_data = Object.assign(_cookieToken, { remember });
            tokenObj = resfresh_data;
        }
    }
    return tokenObj;
};

export const getToken = async () => {
    try {
        let objToken = null
        objToken = cookie.get(COOKIE_JWT);
        if (objToken) return objToken;
        axios.get('http://localhost:8000/api/cookie').then(res => {
            // console.log({res})
            return res.data
        })
        .catch(err => {
            // console.log(err);
            return null
        });
    } catch (error) {
        // console.log({error})
        return null
    }
}
